(() => {
  const normalizeFlagImages = (scope = document) => {
    const selector = [
      'img[src*="flagcdn.com/"]',
      '.currency-switcher img',
      '[data-currency-switcher] img',
      '.pl-localization img',
      'localization-form img'
    ].join(',');
    const images = [];
    if (scope instanceof HTMLImageElement && scope.matches(selector)) images.push(scope);
    if (scope.querySelectorAll) images.push(...scope.querySelectorAll(selector));

    images.forEach((image) => {
      if (!image.hasAttribute('alt')) image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      if (!image.hasAttribute('width')) image.width = 20;
      if (!image.hasAttribute('height')) image.height = 15;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeFlagImages(), { once: true });
  } else {
    normalizeFlagImages();
  }

  document.addEventListener('shopify:section:load', (event) => normalizeFlagImages(event.target));
})();
